import React, { useEffect, useState } from 'react';
import { useInstallationContext } from '../../../../context/installation';
import { UserPermissionType } from '../../../../data-access/gql-types/graphql';
import { useDialogsShared } from '../../../../modules/dialogs/hooks/use-dialogs-shared';
import { useUserPermissions } from '../../../../hooks/user/use-user-permissions';
import { EvaluateAppDialog } from '../../../../modules/dialogs/components/evaluate-app-dialog/evaluate-app-dialog';
import { NativeAppDialog } from '../../../../modules/dialogs/components/native-app-dialog/native-app-dialog';
import { diffHours } from '../../../../utils/helpers/time-convert';
import { useDevicesAndChannelsContext } from '../../context/devices-and-channels';
import * as storage from '../../storage';
import { UpdateDevicesDialog } from './components/update-devices-dialog/update-devices-dialog';

export const DialogsLavva: React.FC = () => {
  const [updateDevicesDialog, setUpdateDevicesDialog] = useState<boolean>(false);
  const { nativeAppOpen, evaluateAppOpen, setEvaluatePopupOpen } = useDialogsShared();
  const { permissions } = useUserPermissions();
  const { selectedInstallationId } = useInstallationContext();
  const { deviceList } = useDevicesAndChannelsContext();
  const updateDevicesPopupAvailable = permissions[UserPermissionType.DeviceList];

  useEffect(() => {
    if (deviceList.length && updateDevicesPopupAvailable) {
      if (
        deviceList.find((x) => x.payload.isUpdateAvailable) &&
        deviceList[0].installationId === selectedInstallationId
      ) {
        const updateDevicesMemory = storage.getItem('updateDevicesMemory');

        if (updateDevicesMemory) {
          if (selectedInstallationId in updateDevicesMemory) {
            if (diffHours(new Date(updateDevicesMemory[selectedInstallationId]), 168)) setUpdateDevicesDialog(true);
          } else setUpdateDevicesDialog(true);
        } else setUpdateDevicesDialog(true);
      }
    }
  }, [deviceList, selectedInstallationId, updateDevicesPopupAvailable]);

  if (nativeAppOpen) {
    return <NativeAppDialog />;
  }

  if (evaluateAppOpen) {
    return <EvaluateAppDialog showDialog={evaluateAppOpen} setShowDialog={setEvaluatePopupOpen} />;
  }

  if (updateDevicesDialog) {
    return <UpdateDevicesDialog showDialog={updateDevicesDialog} setShowDialog={setUpdateDevicesDialog} />;
  }

  return null;
};
